import { useQuery } from "@tanstack/react-query";
import WarehouseService from "../services/Warehouses/WarehouseService";

const useWarehouseZoneTypes = () => {
  return useQuery({
    queryKey: ["zoneTypes"],
    queryFn: async () => await WarehouseService.getZoneTypes(),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};

export default useWarehouseZoneTypes;